module.exports = {
  host: {
	java: 'http://114.55.184.18:80',
	//java: 'http://121.196.192.160:8080',
	pine: 'http://114.55.184.18:80/youqu/pine',
  }
};
